// Same limit as the api, which rejects a longer dress code.
export const DRESS_CODE_MAX_LENGTH = 500;

export const normalizeDressCode = (dressCode) =>
    typeof dressCode === "string" ? dressCode.trim() : "";
